import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { RouterProvider } from "react-router-dom";

import { SOWProvider } from "./contexts/SOWContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Suspense } from "react";
import { Toaster as Sonner } from "./components/ui/sonner";

import SocialProofToasts from "./components/SocialProofToasts";
import UnicornBackground from "./components/UnicornBackground";
import { router } from "./router";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <TooltipProvider>
        <AuthProvider>
          <SOWProvider>
            <Suspense fallback={null}>
              <UnicornBackground />
              <SocialProofToasts />
            </Suspense>
            <Toaster />
            <Suspense fallback={null}>
              <Sonner />
            </Suspense>
            <RouterProvider router={router} />
          </SOWProvider>
        </AuthProvider>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
